import React from 'react'
import './App.css'
import logo from './assets/StrataLensLogoClear.png'
import bgImage from './assets/SL_bg_image.png'

function App() {
  return (
    <div className="app" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="overlay" />
      <div className="container">
        <img src={logo} alt="StrataLens" className="logo" />
        <h1 className="tagline">Mineral Exploration Platform</h1>
        <p className="description">
          Machine learning-powered prospectivity modeling, interactive geospatial maps,
          and exploration data management — built for geologists.
        </p>

        <div className="features">
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <h3>Interactive Maps</h3>
            <p>Visualize magnetic surveys, derivatives, and assay data on interactive maps with real-time layer controls.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
              </svg>
            </div>
            <h3>ML Targeting</h3>
            <p>Upload your training data and generate probability rasters that identify high-potential exploration targets.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <h3>Browser-Based</h3>
            <p>No desktop software or expensive licenses. Your team accesses the same data in real time from any browser.</p>
          </div>
        </div>

        <p className="coming-soon">Coming Soon</p>

        <p className="contact">
          For more information, please reach out to{' '}
          <a href="mailto:hello@stratalens.ca">hello@stratalens.ca</a>
        </p>

        <p className="built-in-canada">Built in Canada.</p>
      </div>
    </div>
  )
}

export default App
